import React from 'react';
import { useLocation } from '../context/LocationContext';
import './LocationChangeModal.css';

const LocationChangeModal = () => {
  const { showChangeModal, handleConfirmChange, handleCancelChange } = useLocation();

  if (!showChangeModal) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Change Pickup Location?</h2>
        <p>Changing the pickup location will clear your current cart. Would you like to continue?</p>
        <div className="modal-actions">
          <button
            className="modal-btn modal-btn-cancel"
            onClick={handleCancelChange}
          >
            Cancel
          </button>
          <button
            className="modal-btn modal-btn-continue"
            onClick={handleConfirmChange}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocationChangeModal;
